var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-light p-4",attrs:{"id":"tmpPage"}},[_vm._m(0),_vm._m(1),_c('div',[_c('img',{staticClass:"logo",attrs:{"src":_vm.logoImage,"alt":"Logotipo de la empresa"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('b',[_vm._v("TEMPORALMENTE INACTIVO")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_vm._v("El sitio web esta temporalmente inactivo debido a su mantenimiento."),_c('br'),_vm._v("Rogamos disculpen las molestias.")])
}]

export { render, staticRenderFns }